import { Borders } from 'baseui/theme';
import { primitives } from './primitives';

export const borders: Borders = {
  border100: {
    borderColor: primitives.primary400,
    borderStyle: 'solid',
    borderWidth: '1px',
  },
  border200: {
    borderColor: primitives.primary400,
    borderStyle: 'solid',
    borderWidth: '2px',
  },
  border300: {
    borderColor: 'hsla(0, 0%, 0%, 0.12)',
    borderStyle: 'solid',
    borderWidth: '1px',
  },
  border400: {
    borderColor: 'hsla(0, 0%, 0%, 0.16)',
    borderStyle: 'solid',
    borderWidth: '1px',
  },
  border500: {
    borderColor: 'hsla(0, 0%, 0%, 0.2)',
    borderStyle: 'solid',
    borderWidth: '1px',
  },
  border600: {
    borderColor: 'hsla(0, 0%, 0%, 0.24)',
    borderStyle: 'solid',
    borderWidth: '1px',
  },
  radius100: '4px',
  radius200: '6px',
  radius300: '8px',
  radius400: '12px',
  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: true,
  /** Button, ButtonGroup */
  buttonBorderRadius: '6px',
  /** Input, Select, Textarea, Checkbox */
  inputBorderRadius: '6px',
  /** Popover, Menu, Tooltip */
  popoverBorderRadius: '0px',
  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: '0px',
};
